import { createContext } from 'react';

const DealsContext = createContext();

export default DealsContext;
